import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Copy, QrCode, Check } from "lucide-react";
import { useI18n } from "../i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function ShareBadge({ url, compact = false }) {
  const { tr } = useI18n();
  const [link, setLink] = useState(null);
  const [copied, setCopied] = useState(false);
  const [showQr, setShowQr] = useState(!compact);

  useEffect(() => {
    setLink(null);
    axios.post(`${API}/shortlink`, { long_url: url }).then((r) => setLink(r.data)).catch(() => {});
  }, [url]);

  if (!link) return null;
  const qrSrc = link.qr_url.startsWith("/") ? `${BACKEND}${link.qr_url}` : link.qr_url;
  const display = link.short_url.replace(/^https?:\/\//, "");

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link.short_url);
      setCopied(true);
      toast.success(tr("Link copied!"));
      setTimeout(() => setCopied(false), 2000);
    } catch (_) {
      toast.info(link.short_url);
    }
  };

  return (
    <div data-testid="share-badge" className="border border-[#DCE8F7] bg-[#F6FAFF] rounded-2xl p-3 flex items-center gap-3">
      {showQr ? (
        <img data-testid="share-badge-qr" src={qrSrc} alt={`QR — ${display}`} className="w-20 h-20 rounded-lg border border-[#DCE8F7] bg-white shrink-0" />
      ) : (
        <button data-testid="share-badge-qr-toggle" onClick={() => setShowQr(true)} className="w-10 h-10 rounded-lg border border-[#BFD4F2] bg-white flex items-center justify-center text-[#2563EB] hover:bg-[#EAF2FD] transition-colors shrink-0">
          <QrCode size={18} />
        </button>
      )}
      <div className="min-w-0 flex-1">
        <div className="text-[0.55rem] font-extrabold tracking-widest uppercase text-[#64748B]">
          {tr("Scan or share")} · {link.provider === "splink" ? "SpLink.pro" : tr("QR")}
        </div>
        <div data-testid="share-badge-url" className="font-mono-wp text-xs text-[#0F2557] font-semibold truncate mt-0.5">{display}</div>
        <button
          data-testid="share-badge-copy"
          onClick={copy}
          className="mt-1.5 inline-flex items-center gap-1.5 text-[0.65rem] font-bold text-[#2563EB] hover:text-[#1D4ED8] transition-colors"
        >
          {copied ? <Check size={11} /> : <Copy size={11} />} {copied ? tr("Copied") : tr("Copy link")}
        </button>
      </div>
    </div>
  );
}
